import { API_BASE_URL } from '../config';

export async function fetchShopProducts() {
  const res = await fetch(`${API_BASE_URL}/api/shop/products`);
  if (!res.ok) throw new Error('Could not load products.');
  return res.json();
}

export async function fetchShopConfig() {
  const res = await fetch(`${API_BASE_URL}/api/shop/config`);
  if (!res.ok) return { publishableKey: null, stripeEnabled: false };
  return res.json();
}

export async function createCheckout({ items, customerEmail }) {
  const res = await fetch(`${API_BASE_URL}/api/shop/checkout`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items, customerEmail: customerEmail || undefined }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.message || 'Checkout failed.');
  return data;
}
